import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import tw from "twin.macro";
import {
  Language, EnquierySource, EnquieryStatus, EmplyeeId,
  EnquieryTypeId, createEnquiry, getEnquiryByPage,
} from "../api/BookAnAppointmentApi.js";
import { getBranchId, getCustomerId } from "../utility/HeaderConfig.js";
import { currentDateToUtcDate, currentRegister } from "../utility/Constant";
import moment from "moment";
import { CustomerAutoSearch } from "../api/CustomerApi";
import toast, { Toaster } from "react-hot-toast";
import Noimg from "../images/no_img.jpg";
import { getAllProductsType } from "../api/ProductTypeApi.js";
import SEO from "components/headers/Seo.js";
// import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Named export kept for BestSelling, TrendOnShops, ShopOurExclusives
export const Heading = tw.h1`text-center block text-black font-bold text-3xl m-0 py-2 uppercase border-b-2 border-custom-100`;

const Container = tw.div`relative`;

const STEPS = [
  { icon: "📋", title: "Fill the Form", desc: "Enter your details and preferred date & time" },
  { icon: "📞", title: "Confirmation", desc: "Our team confirms your slot via call or SMS" },
  { icon: "💎", title: "Visit & Shop", desc: "Enjoy a personalised jewellery experience" },
];

const inputS = {
  display: "block", width: "100%", padding: "12px 14px 12px 42px",
  fontFamily: "inherit", fontSize: 14, color: "#1c1c1e",
  background: "#f6f3f9d8", border: "1px solid #f6f3f9d8",
  borderRadius: 10, outline: "none",
  transition: "border-color .14s, box-shadow .14s",
};
const labelS = {
  display: "block", fontSize: 11, fontWeight: 600,
  color: "#4f3267", letterSpacing: ".07em",
  textTransform: "uppercase", marginBottom: 6,
};
const errS = { display: "block", fontSize: 11.5, color: "#e53e3e", marginTop: 4 };

function FieldWrap({ icon, children }) {
  return (
    <div style={{ position: "relative" }}>
      <span style={{
        position: "absolute", left: 14, top: "50%",
        transform: "translateY(-50%)", color: "#4f2a64",
        pointerEvents: "none", display: "flex", alignItems: "center",
      }}>
        {icon}
      </span>
      {children}
    </div>
  );
}

export default function BookAnAppointment({ configImages }) {
  const [name, setName] = useState("");
  const [mobileno, setmobileno] = useState("");
  const [email, setemail] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [language, setLanguage] = useState([]);
  const [languageid, setLanguageid] = useState("");
  const [scheduleDate, setScheduleDate] = useState(
    moment().add(1, "hours").format("YYYY-MM-DDTHH:mm")
  );
  const [duration, setDuration] = useState(30);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [customerId, setCustomerId] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState("");
  const [invalidMobile, setinvalidMobile] = useState("");
  const [availableMobile, setAvailableMobile] = useState("");
  const [validInput, setValidInput] = useState(false);
  const [validTime, setValidTime] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [Latitude, setLatitude] = useState("");
  const [Longitude, setLongitude] = useState("");
  const [EnquieryId, setEnquieryId] = useState("");
  const [EnquieryStatusId, setEnquieryStatusId] = useState("");
  const [EmployeeId, setEmployeeId] = useState("");
  const [EnquieryTypeid, setEnquieryTypeid] = useState("");
  const [banner, setBanner] = useState([]);                 // eslint-disable-line
  const [metalTypeList, setMetalTypeList] = useState([]);
  const [metalTypeid, setMetalTypeid] = useState("");

  useEffect(() => {
    Selectlanguage();
    EnquierySourceId();
    EnquierySourceStatus();
    EnquieryEmployeeId();
    EnquieryType();
    GeoLocation();
    getBanner();
    selectMetalType();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const minDate = moment().add(1, "hours").format("YYYY-MM-DDTHH:mm");
    setValidTime(scheduleDate >= minDate);
  }, [scheduleDate]);

  const getBanner = () => {
    configImages?.E_COMMERCE_BANNERS?.forEach((d) => {
      if (d.key === "enquiry") setBanner(d.value);
    });
  };

  const location = useLocation();
  const myparam = location.state;

  const Selectlanguage = async () => {
    const res = await Language();
    const list = (res.response || []).map((i) => ({ value: i.id, title: i.languageName }));
    setLanguage(list);
    const tamil = list.find((l) => l.title.toLowerCase() === "tamil");
    if (tamil) setLanguageid(tamil.value);
    setSelectedProduct(myparam || null);
    if (getCustomerId()) setCustomerId(true);
  };

  const selectMetalType = async () => {
    const res = await getAllProductsType({});
    const list = res.response
      .filter((i) => ["gold","silver","diamond"].includes(i.name.toLowerCase()))
      .map((i) => ({ value: i.id, title: i.name }));
    setMetalTypeList(list);
    setSelectedProduct(myparam || null);
    if (getCustomerId()) setCustomerId(true);
  };

  const EnquierySourceId = () => {
    EnquierySource().then((d) => {
      const found = d.response.filter((i) => i.name === "MOBILE_LIVE");
      setEnquieryId(found);
    });
  };

  const EnquierySourceStatus = () => {
    EnquieryStatus().then((d) => {
      const hot = (d.response || []).find((i) => i.name?.toLowerCase() === "hot");
      setEnquieryStatusId(hot ? hot.id : "");
    });
  };

  const EnquieryEmployeeId = () => {
    EmplyeeId(JSON.stringify({ name: "ONLINEPAYMENT" })).then((d) => {
      setEmployeeId(d.response?.find((item) => item.name === "ONLINEPAYMENT")?.id);
    });
  };

  const EnquieryType = () => {
    EnquieryTypeId().then((d) => {
      const sales = (d.response || []).find((i) => i.name?.toLowerCase() === "sales");
      setEnquieryTypeid(sales ? sales.id : "");
    });
  };

  const GeoLocation = () => {
    navigator.geolocation?.getCurrentPosition(
      (pos) => { setLatitude(pos.coords.latitude); setLongitude(pos.coords.longitude); },
      (err) => console.error(err)
    );
  };

  const textarea = `Schedule a Video Demo for me with Video Live at ${moment(scheduleDate).format("DD-MM-YYYY hh:mm A")}`;

  const validateField = () => {
    const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; // eslint-disable-line
    const mobileReg = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (!emailReg.test(email) && email !== "") setInvalidEmail("Email is invalid");
    else setInvalidEmail("");
    if (!mobileReg.test(mobileno) && mobileno !== "") setinvalidMobile("Mobile is invalid");
    else setinvalidMobile("");

    if (
      emailReg.test(email) && mobileReg.test(mobileno) &&
      name !== "" && languageid !== "" && scheduleDate !== "" &&
      metalTypeid !== "" && validTime
    ) return true;

    if (validTime && customerId && languageid !== "" && metalTypeid !== "") return true;

    setValidInput(true);
    return false;
  };

  const submitForm = () => {
    if (!getCustomerId()) {
      toast.error("Please sign in to book an appointment", { position: "top-right" });
      return;
    }
    if (validateField()) customerAutoSearch();
  };

  const customerAutoSearch = () => {
    setLoading(true);
    if (mobileno.trim().length > 0) {
      CustomerAutoSearch(`mobile=${mobileno}&branchId=${getBranchId()}&beforeCreatedAt=${currentRegister()}`)
        .then((d) => {
          if (d.response?.length > 0 && mobileno.trim().length > 0) {
            setAvailableMobile("Customer already exists for this mobile number");
            setLoading(false);
          } else if (selectedProduct && customerId) {
            getEnquiryByPage(JSON.stringify({
              customerEntity: getCustomerId(),
              branchDetailsEntity: getBranchId(),
              productEntity: selectedProduct.id,
            })).then((res) => {
              if (res.response.content?.length > 0) {
                toast.error("Appointment already booked for this product!", { duration: 2000, position: "top-right" });
                setLoading(false);
              } else {
                setAvailableMobile("");
                postAjaxRequest();
              }
            });
          } else {
            setAvailableMobile("");
            postAjaxRequest();
          }
        });
    } else {
      postAjaxRequest();
    }
  };

  const postAjaxRequest = () => {
    setLoading(true);
    const demoEndDate = moment(scheduleDate, "YYYY-MM-DDThh:mm").add(duration, "minutes").format("DD-MM-YYYY hh:mm A");
    const newDemoStartDate = moment(scheduleDate, "YYYY-MM-DDThh:mm").format("YYYY-MM-DD HH:mm:ss");
    const newDemoEndDate = moment(demoEndDate, "DD-MM-YYYY hh:mm A").format("YYYY-MM-DD HH:mm:ss");
    const contactNumber = mobileno !== "" ? mobileno : null;
    const currentDateAndTime = currentRegister();

    const customerData = customerId
      ? { id: getCustomerId() }
      : {
          branchId: getBranchId(), name,
          mobile: contactNumber, email: email || null,
          enquirySource: "WEB", crmStatus: "ENGAGING",
          enrollmentDate: currentDateToUtcDate(currentDateAndTime),
          customerAddress: { latitude: Latitude || 0, longtitude: Longitude || 0 },
          countryCode: "+91", customerType: "CUSTOMER", homeCountry: "LOCAL",
        };

    createEnquiry(JSON.stringify({
      customer: customerData,
      enquirySourceId: EnquieryId?.[0]?.id,
      enquiryStatusId: EnquieryStatusId,
      enqGeneratedById: EmployeeId,
      productId: selectedProduct?.id || null,
      prevFollowUpDate: currentDateToUtcDate(newDemoStartDate),
      nextFollowUpDate: currentDateToUtcDate(newDemoEndDate),
      enquiryTypeId: EnquieryTypeid,
      reqDetails: enquiry !== "" ? enquiry : textarea,
      branchId: getBranchId(),
      languageId: languageid || null,
      metalTypeid: metalTypeid || null,
    }))
      .then(() => {
        toast.success("Appointment booked successfully!", { duration: 2500, position: "top-right" });
        setLoading(false); setValidInput(false);
        setName(""); setmobileno(""); setemail(""); setDuration(30); setEnquiry("");
      })
      .catch(() => {
        toast.error("Appointment already booked for this product!", { duration: 2000, position: "top-right" });
        setLoading(false);
      });
  };

  const selectS = {
    ...inputS, paddingLeft: 14,
    appearance: "none", WebkitAppearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
    backgroundPosition: "right 10px center",
    backgroundRepeat: "no-repeat",
    backgroundSize: 20,
    paddingRight: 36,
  };

  return (
    <Container>
      <SEO title="Book An Appointment — AVM Jewellers" description="Schedule a visit." name="AVM Jewellers" type="article" />
      <Toaster position="top-right" />

      {/* Banner */}
      {/* {banner?.length > 0 ? (
        <div style={{ position: "relative", maxHeight: 240, overflow: "hidden" }}>
          <img
            src={banner}
            alt="Book An Appointment"
            style={{ width: "100%", objectFit: "cover", maxHeight: 240, display: "block" }}
          />
          <div style={{
            position: "absolute", inset: 0,
            background: "rgba(0,0,0,.42)",
            display: "flex", alignItems: "center", padding: "0 5%",
          }}>
            <div>
              <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#a85ad4" }}>
                AVM Jewellers
              </p>
              <h1 style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontSize: "clamp(28px,4vw,48px)", fontWeight: 500, color: "#fff", margin: 0 }}>
                Book {selectedProduct ? "An Enquiry" : "An Appointment"}
              </h1>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ background: "#faf6ee", padding: "48px 0", textAlign: "center", borderBottom: "1px solid #d6b0f0" }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "#a85ad4", margin: "0 0 8px" }}>
            AVM Jewellers
          </p>
          <h1 style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontSize: "clamp(28px,4vw,48px)", fontWeight: 500, color: "#1c1c1e", margin: 0 }}>
            Book {selectedProduct ? "An Enquiry" : "An Appointment"}
          </h1>
        </div>
      )} */}

      {/* Breadcrumb */}
      <div
        className="ptSans px-sm-5 px-0"
        tw="text-sm pt-3"
        style={{ background: "var(--surface-cream)", height: "70px" }}
      >
        <div
          tw="ml-3 text-custom-100 capitalize tracking-wide"
          style={{
            color: "var(--ink-700)",
            fontWeight: 500,
            textTransform: "capitalize",
          }}
        >
          YOUR APPOINTMENT
        </div>
        <Link
          to="/"
          tw="mx-3 no-underline"
          style={{
            color: "var(--ink-700)",
            textDecoration: "none",
            fontWeight: 400,
            fontSize: "10px",
          }}
        >
          HOME
        </Link>
        {">"}
        <span
          tw="ml-3 text-custom-100 capitalize tracking-wide"
          style={{
            color: "var(--ink-700)",
            fontWeight: 400,
            textTransform: "capitalize",
            fontSize: "10px",
          }}
        >
          BOOK AN APPOINTMENT
        </span>
      </div>

      <div className="container mt-4" style={{ paddingBottom: 80 }}>
        <div className="row gy-5">

          {/* Left: How it works */}
          <div className="col-lg-5">

            {/* Selected product card */}
            {selectedProduct && (
              <div style={{ padding: 20, background: "#fdfbf7", border: "1.5px solid #f0ddb0", borderRadius: 16, marginBottom: 28 }}>
                <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "#b8860b", margin: "0 0 12px" }}>
                  Selected Product
                </p>
                <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
                  <img
                    src={selectedProduct.images === "@#@" ? Noimg : selectedProduct.images?.split("@#@")[0]}
                    alt="Product"
                    style={{ width: 72, height: 72, objectFit: "cover", borderRadius: 10, border: "1px solid #f0ddb0", flexShrink: 0 }}
                  />
                  <div>
                    <p style={{ margin: "0 0 4px", fontSize: 14, fontWeight: 600, color: "#1c1c1e" }}>{selectedProduct.category}</p>
                    <p style={{ margin: "0 0 4px", fontSize: 12.5, color: "#6c6c70" }}>
                      {selectedProduct.goldPurity} {selectedProduct.metalType} · {selectedProduct.productCode}
                    </p>
                    <p style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#b8860b", fontFamily: "Cormorant Garamond, Georgia, serif" }}>
                      ₹{Math.trunc(selectedProduct.total).toLocaleString("en-IN")}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Steps */}
            <h3 style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontSize: 22, fontWeight: 500, color: "#4f3267", marginBottom: 20 }}>
              How it works
            </h3>
            {STEPS.map((s, i) => (
              <div key={i} style={{ display: "flex", gap: 16, marginBottom: 20, alignItems: "flex-start" }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 12,
                  background: "#faf7fd", border: "1px solid #d8b0f0",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 20, flexShrink: 0,
                }}>
                  {s.icon}
                </div>
                <div>
                  <p style={{ margin: "0 0 3px", fontWeight: 600, fontSize: 14.5, color: "#855ad4" }}>{s.title}</p>
                  <p style={{ margin: 0, fontSize: 13, color: "#3c1e6d", lineHeight: 1.6 }}>{s.desc}</p>
                </div>
              </div>
            ))}

            <div style={{ marginTop: 24, padding: "16px 20px", background: "#faf7fd", border: "1px solid #d8b0f0", borderRadius: 12 }}>
              <p style={{ margin: 0, fontSize: 13, color: "#bd6af8", lineHeight: 1.7 }}>
                <strong style={{ color: "#4f3267" }}>Safety First:</strong> We sanitise all jewellery pieces before and after any trials to ensure a safe shopping experience.
              </p>
            </div>
          </div>

          {/* Right: Form */}
          <div className="col-lg-7">
            <div style={{ borderLeft: "1px solid #f2dffd", borderRadius: 20, padding: "36px 32px" }}>
              <h3 style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontSize: 22, fontWeight: 500, color: "#4f3267", margin: "0 0 24px" }}>
                Your Details
              </h3>

              {/* Guest fields */}
              {!customerId && (
                <div className="row gy-3" style={{ marginBottom: 4 }}>
                  <div className="col-sm-6">
                    <label style={labelS}>Full Name *</label>
                    <FieldWrap icon={
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                      </svg>
                    }>
                      <input
                        type="text" value={name} onChange={(e) => setName(e.target.value)}
                        placeholder="Your name"
                        style={{ ...inputS, borderColor: name === "" && validInput ? "#e53e3e" : "#e5e5ea" }}
                      />
                    </FieldWrap>
                    {name === "" && validInput && <span style={errS}>Name is required</span>}
                  </div>

                  <div className="col-sm-6">
                    <label style={labelS}>Mobile Number *</label>
                    <FieldWrap icon={
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.95 9.91a19.79 19.79 0 01-3.07-8.67A2 2 0 012.88 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
                      </svg>
                    }>
                      <input
                        type="tel" value={mobileno.replace(/\s+/g, "")}
                        onChange={(e) => setmobileno(e.target.value)}
                        placeholder="10-digit number"
                        style={{ ...inputS, borderColor: (mobileno === "" && validInput) || invalidMobile || availableMobile ? "#e53e3e" : "#e5e5ea" }}
                      />
                    </FieldWrap>
                    {availableMobile && <span style={errS}>{availableMobile}</span>}
                    {invalidMobile && <span style={errS}>{invalidMobile}</span>}
                  </div>

                  <div className="col-12">
                    <label style={labelS}>Email Address *</label>
                    <FieldWrap icon={
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                    }>
                      <input
                        type="email" value={email}
                        onChange={(e) => setemail(e.target.value)}
                        placeholder="you@example.com"
                        style={{ ...inputS, borderColor: invalidEmail ? "#e53e3e" : "#e5e5ea" }}
                      />
                    </FieldWrap>
                    {invalidEmail && <span style={errS}>{invalidEmail}</span>}
                  </div>
                </div>
              )}

              <div className="row gy-3" style={{ marginTop: customerId ? 0 : 8 }}>
                {/* Language */}
                <div className="col-sm-6">
                  <label style={labelS}>Preferred Language *</label>
                  <select
                    value={languageid}
                    onChange={(e) => setLanguageid(e.target.value)}
                    style={{ ...selectS, borderColor: languageid === "" && validInput ? "#e53e3e" : "#e5e5ea" }}
                  >
                    <option value="">Select language</option>
                    {language?.map((l) => <option key={l.value} value={l.value}>{l.title}</option>)}
                  </select>
                  {languageid === "" && validInput && <span style={errS}>Language is required</span>}
                </div>

                {/* Metal type */}
                <div className="col-sm-6">
                  <label style={labelS}>Metal Type *</label>
                  <select
                    value={metalTypeid}
                    onChange={(e) => setMetalTypeid(e.target.value)}
                    style={{ ...selectS, borderColor: metalTypeid === "" && validInput ? "#e53e3e" : "#e5e5ea" }}
                  >
                    <option value="">Select metal</option>
                    {metalTypeList?.map((m) => <option key={m.value} value={m.value}>{m.title}</option>)}
                  </select>
                  {metalTypeid === "" && validInput && <span style={errS}>Metal type is required</span>}
                </div>

                {/* Date */}
                <div className="col-sm-6">
                  <label style={labelS}>Date & Time *</label>
                  <input
                    type="datetime-local"
                    value={scheduleDate}
                    min={moment().add(1, "hours").format("YYYY-MM-DDTHH:mm")}
                    onChange={(e) => setScheduleDate(e.target.value)}
                    style={{ ...inputS, paddingLeft: 14, borderColor: !validTime ? "#e53e3e" : "#e5e5ea" }}
                  />
                  {!validTime && <span style={errS}>Select a future date & time</span>}
                </div>

                {/* Duration */}
                <div className="col-sm-6">
                  <label style={labelS}>Duration</label>
                  <select value={duration} onChange={(e) => setDuration(e.target.value)} style={selectS}>
                    {[15, 30, 45, 60].map((d) => <option key={d} value={d}>{d} minutes</option>)}
                  </select>
                </div>

                {/* Notes */}
                <div className="col-12">
                  <label style={labelS}>Additional Notes <span style={{ fontWeight: 400, textTransform: "none" }}>(Optional)</span></label>
                  <textarea
                    rows={3}
                    value={enquiry}
                    onChange={(e) => {
                      if (e.target.value.length === 1) setEnquiry(`${textarea} Additional Details: ${e.target.value}`);
                      else setEnquiry(e.target.value);
                    }}
                    placeholder={textarea}
                    style={{ ...inputS, paddingLeft: 14, resize: "none", paddingTop: 12 }}
                  />
                </div>
              </div>

              {/* Submit */}
              <button
                onClick={submitForm}
                disabled={Loading}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  width: "100%", marginTop: 24, padding: "14px",
                  background: Loading ? "#c7c7cc" : "#4f3267", color: "#fff",
                  fontSize: 14, fontWeight: 600, letterSpacing: ".05em",
                  border: "none", borderRadius: 10,
                  cursor: Loading ? "not-allowed" : "pointer",
                  transition: "background .14s",
                }}
                onMouseEnter={(e) => { if (!Loading) e.currentTarget.style.background = "#7517b4"; }}
                onMouseLeave={(e) => { if (!Loading) e.currentTarget.style.background = "#4f3267"; }}
              >
                {Loading ? "Booking…" : "Book Appointment"}
                {!Loading && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <line x1="5" y1="12" x2="19" y2="12"/>
                    <polyline points="12 5 19 12 12 19"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}